export default "__VITE_ASSET__727162f5__"